import { postWithAuth } from '@/lib/httpAdapter';
import { IssueReqOrg, IssueReqInd } from '@/types/issueReqType';
import Issue from '@/types/issueType';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const endPoint = 'fetchIssuesForUser/';
const url = apiUrl + endPoint;

// The return from the end point returns a numebr for the field TicketNumber while the db saves TicketUUID as a string
const convertTicketNumberToString = (issues: Issue[]): Issue[] => {
  try {
    return issues.map((issue) => ({
      ...issue,
      TicketNumber: issue.TicketNumber.toString(),
    }));
  } catch (err) {
    return [];
  }
};
// const handleErrorSignOut = () => {
//   // Sign out the user using NextAuth.js
//   // signOut({ redirect: false, callbackUrl: '/login' });

//   const toast = useToast();
//   toast({
//     title: 'Session Expired',
//     description: 'Your token has expired. Please sign in with GitHub again. You are being redirected',
//     status: 'info',
//     duration: 4000, // Optional: Set the duration for which the modal is displayed
//     isClosable: true,
//   });
//   setTimeout(() => {
//     signOut({ redirect: false, callbackUrl: 'http://localhost:3000/login' });
//   }, 5000);
// }
export const fetchIssuesForOrg = async (
  req: IssueReqOrg,
  headerObj: headerObject
) => {
  try {
    const res = await postWithAuth(
      apiUrl + 'fetchIssuesForOrg/',
      {
        UserUUID: req.UserUUID,
        OrganizationUUID: req.OrganizationUUID,
        Source: req.Source,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    const issues = convertTicketNumberToString(data.Issues);
    return issues;
  } catch (err) {
    console.error(err);
  }
};

export const fetchIssuesForIndividual = async (
  req: IssueReqInd,
  headerObj: headerObject
) => {
  try {
    const res = await postWithAuth(
      url,
      {
        RepositoryUUID: req.RepositoryUUID,
        UserUUID: req.UserUUID,
        Source: req.Source,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    const issues = convertTicketNumberToString(data.Issues);
    return issues;
  } catch (err) {
    console.error(err);
  }
};

export const fetchIssuesForLoggedOutUser = async (reponame: string) => {
  try {
    const res = await postWithAuth(
      url,
      {
        RepositoryName: reponame,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    const issues = convertTicketNumberToString(data.Issues);
    return issues;
  } catch (err) {
    console.error(err);
  }
};
